export default "__VITE_PUBLIC_ASSET__34d316fe__"